/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { request } from '@mairistem/tools';
import { App, Feature, Menu, render } from '@mairistem/module';
import { Icon, Tooltip } from '@mairistem/composants';

import { Context } from '@/components/Context';
import { ModalToastContainer } from '@/components/Common';

import { useEntiteStore } from './zustand';

import { initialize } from './sentry';

import './index.less';
import 'react-toastify/dist/ReactToastify.css';
import { Assistant } from './components/Assistant';
import { Dashboard } from './components/Dashboard';

initialize();

request.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === 'production') {
    if (_.includes(window.location.href, '.jvsonline.fr')) {
      config.baseURL = 'https://360.jvsonline.fr';
    } else if (_.includes(window.location.href, '.qa.')) {
      config.baseURL = 'https://360.qa.jvs-mairistem.dev';
    } else if (_.includes(window.location.href, '.pp.')) {
      config.baseURL = 'https://360.pp.jvs-mairistem.dev';
    } else {
      config.baseURL = 'https://360.jvs-mairistem.dev';
    }
  }

  return config;
});

const EntiteHandler = () => {
  const setRefresh = useEntiteStore((state) => state.setRefresh);

  useEffect(() => {
    setRefresh(true);
  }, [setRefresh]);

  return <div />;
};

const code = '360_AAM';
const showTooltips = !window.location.href.includes('360');

// Ne pas modifier ou supprimer
// Utile en mode production afin que le style se place au bonne endroit
if (process.env.NODE_ENV !== 'development') {
  const oldCreatePortal = ReactDOM.createPortal;

  ReactDOM.createPortal = (child, domNode) =>
    oldCreatePortal(
      child,
      domNode === document.body
        ? document.querySelector(`#${CSS.escape(code)}`) || domNode
        : domNode || document.querySelector(`#${CSS.escape(code)}`),
    );
}

render(
  <App
    group="administres"
    name="AAM"
    code={code}
    request={request}
    context={Context as React.ComponentType<unknown>}
  >
    <Menu
      name="Entités"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="building" />}
            message="Entités"
            position="right center"
          />
        ) : (
          <Icon name="building" />
        )
      }
      path="/entites"
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <EntiteHandler />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Accueil"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="home" />}
            message="Accueil"
            position="right center"
          />
        ) : (
          <Icon name="home" />
        )
      }
      path="/"
      exact
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <Dashboard />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu
      name="Assistant"
      icon={
        showTooltips ? (
          <Tooltip
            trigger={<Icon name="home" />}
            message="Assistant"
            position="right center"
          />
        ) : (
          <Icon name="home" />
        )
      }
      path="/assistant"
      exact
    >
      <Feature>
        <Feature.Content>
          <>
            <ModalToastContainer />
            <Assistant />
          </>
        </Feature.Content>
      </Feature>
    </Menu>
  </App>,
);
